<template>
  <page-header-wrapper>
    <div class="business-page erp-list-page baidao-list-page crm-follow-page">
      <section class="erp-search-card">
        <a-form layout="inline"><a-row :gutter="24">
          <a-col :md="5" :sm="24"><a-form-item label="对象类型"><a-select v-model="query.targetType" allow-clear placeholder="全部"><a-select-option value="lead">线索</a-select-option><a-select-option value="customer">客户</a-select-option></a-select></a-form-item></a-col>
          <a-col :md="5" :sm="24"><a-form-item label="跟进方式"><a-select v-model="query.followUpMethod" allow-clear placeholder="全部"><a-select-option v-for="item in methods" :key="item.dictValue" :value="item.dictValue">{{ item.dictLabel }}</a-select-option></a-select></a-form-item></a-col>
          <a-col :md="5" :sm="24"><a-form-item label="状态"><a-select v-model="query.status" allow-clear placeholder="全部"><a-select-option value="active">有效</a-select-option><a-select-option value="revoked">已撤销</a-select-option></a-select></a-form-item></a-col>
          <a-col :md="24" :sm="24" class="erp-search-actions"><a-button type="primary" icon="search" @click="search">查询</a-button><a-button icon="redo" @click="resetQuery">重置</a-button></a-col>
        </a-row></a-form>
      </section>

      <section class="erp-table-card">
        <div class="erp-table-toolbar"><div><h3>跟进记录单</h3><p>有效跟进必须包含实际时间、方式和内容；编辑与撤销均保留审计记录。</p></div><div class="erp-toolbar-actions"><span class="erp-record-count">共 {{ total }} 条</span><a-button type="primary" icon="plus" @click="openAdd">新增跟进</a-button></div></div>
        <a-table
          row-key="id"
          bordered
          size="middle"
          :columns="columns"
          :data-source="rows"
          :loading="loading"
          :pagination="pagination"
          :scroll="{ x: 1410 }"
          @change="changePage">
          <template slot="followUpNo" slot-scope="text, record"><a @click="openView(record)">{{ text }}</a></template>
          <template slot="targetType" slot-scope="text"><a-tag :color="text === 'lead' ? 'blue' : 'purple'">{{ text === 'lead' ? '线索' : '客户' }}</a-tag></template>
          <template slot="target" slot-scope="text, record">{{ targetLabel(record) }}</template>
          <template slot="followUpMethod" slot-scope="text">{{ dictLabel(methods, text) }}</template>
          <template slot="status" slot-scope="text"><a-tag :color="text === 'active' ? 'green' : 'default'">{{ text === 'active' ? '有效' : '已撤销' }}</a-tag></template>
          <template slot="dateTime" slot-scope="text">{{ formatTime(text) }}</template>
          <template slot="user" slot-scope="text">{{ userLabel(text) }}</template>
          <template slot="attachmentCount" slot-scope="text, record">{{ attachmentCount(record) ? `${attachmentCount(record)} 个` : '—' }}</template>
          <template slot="operation" slot-scope="text, record"><a @click="openView(record)">查看</a><template v-if="record.status === 'active'"><a-divider type="vertical" /><a @click="openEdit(record)">编辑</a><a-divider type="vertical" /><a v-hasPermi="['erp:crm:follow-up:revoke']" @click="openRevoke(record)">撤销</a></template></template>
        </a-table>
      </section>

      <a-drawer
        :visible="editorVisible"
        :width="drawerWidth"
        :closable="false"
        :body-style="{ padding: 0 }"
        :mask-closable="false"
        class="erp-doc-drawer"
        @close="closeEditor">
        <div class="erp-drawer-shell">
          <header class="erp-drawer-header"><div><button class="erp-back-button" type="button" aria-label="返回跟进列表" @click="closeEditor"><a-icon type="arrow-left" /></button><span class="erp-drawer-kicker">{{ readOnly ? '查看跟进' : (form.id ? '编辑跟进' : '新增跟进') }}</span><h3>{{ form.followUpNo || '跟进记录' }}</h3></div><div><a-button @click="closeEditor">{{ readOnly ? '返回列表' : '取消' }}</a-button><a-button v-if="!readOnly" type="primary" :loading="saving" @click="submit">保存</a-button></div></header>
          <div class="erp-drawer-content">
            <div class="erp-status-strip"><a-tag :color="form.status === 'revoked' ? 'default' : 'green'">{{ form.status === 'revoked' ? '已撤销' : '有效跟进' }}</a-tag><span>{{ form.followUpNo || '未生成编号' }} · 跟进人 {{ userLabel(form.creator) }} · 仅修改“下次跟进时间”不构成新的有效跟进；原记录编辑限创建后 24 小时内。</span></div>
            <section class="erp-form-card">
              <div class="erp-section-title"><span class="erp-section-index">01</span><div><h4>跟进内容</h4><p>公海中的线索或客户必须先领取/分配，之后才允许记录跟进</p></div></div>
              <div class="erp-base-grid follow-grid">
                <label><span><b class="erp-required">*</b> 跟进对象</span><a-select v-model="form.targetType" :disabled="readOnly || !!form.id" @change="changeTargetType"><a-select-option value="lead">线索</a-select-option><a-select-option value="customer">客户</a-select-option></a-select></label>
                <label class="target-picker-field"><span><b class="erp-required">*</b> 关联对象</span><a-input :value="selectedTargetName" read-only placeholder="请从档案中选择"><a-button slot="addonAfter" :disabled="!!form.id" @click="openTargetPicker">选择</a-button></a-input></label>
                <label><span>经营主体</span><a-input :value="form.operatingSubjectId == null ? '选择对象后自动带出' : subjectLabel(form.operatingSubjectId)" disabled /></label>
                <label><span><b class="erp-required">*</b> 跟进方式</span><a-select v-model="form.followUpMethod" :disabled="readOnly"><a-select-option v-for="item in methods" :key="item.dictValue" :value="item.dictValue">{{ item.dictLabel }}</a-select-option></a-select></label>
                <label><span>面谈类型</span><a-select v-model="form.interviewType" :disabled="readOnly" allow-clear><a-select-option v-for="item in interviewTypes" :key="item.dictValue" :value="item.dictValue">{{ item.dictLabel }}</a-select-option></a-select></label>
                <label><span><b class="erp-required">*</b> 实际跟进时间</span><a-date-picker v-model="form.followUpTime" :disabled="readOnly" show-time value-format="YYYY-MM-DD HH:mm:ss" style="width:100%" /></label>
                <label><span>下次跟进时间</span><a-date-picker v-model="form.nextFollowUpTime" :disabled="readOnly" show-time value-format="YYYY-MM-DD HH:mm:ss" style="width:100%" /></label>
                <label><span>定位文字</span><a-input v-model.trim="form.locationText" :disabled="readOnly" maxlength="500" placeholder="选填，不采集轨迹" /></label>
                <label class="wide"><span><b class="erp-required">*</b> 跟进内容</span><a-textarea v-model.trim="form.content" :disabled="readOnly" :rows="5" maxlength="4000" /></label>
                <div class="wide crm-follow-upload-field"><span>现场照片</span><crm-follow-up-upload v-model="form.photoUrls" kind="photo" :count="6" :disabled="readOnly" /></div>
                <div class="wide crm-follow-upload-field"><span>附件</span><crm-follow-up-upload v-model="form.attachmentUrls" kind="attachment" :count="6" :disabled="readOnly" /></div>
              </div>
            </section>
          </div>
          <footer class="erp-drawer-footer"><div><a-icon type="info-circle" /> 保存成功后会回写对应线索/客户的最近与下次跟进时间。</div><div><a-button @click="closeEditor">返回列表</a-button><a-button v-if="!readOnly" type="primary" :loading="saving" @click="submit">保存跟进</a-button></div></footer>
        </div>
      </a-drawer>

      <a-modal
        :title="form.targetType === 'customer' ? '选择客户档案' : '选择已分配线索'"
        :visible="targetPickerVisible"
        :footer="null"
        width="920px"
        @cancel="targetPickerVisible=false">
        <div class="crm-picker-search"><a-input-search v-model.trim="targetKeyword" allow-clear placeholder="输入编号、名称、联系人或手机号" enter-button="查询" @search="loadTargetOptions" /></div>
        <a-table
          row-key="id"
          size="middle"
          :columns="pickerColumns"
          :data-source="targetOptions"
          :loading="targetLoading"
          :pagination="false"
          :scroll="{ x: 760 }">
          <template slot="operatingSubject" slot-scope="text">{{ subjectLabel(text) }}</template>
          <template slot="pickerOperation" slot-scope="text, record"><a @click="selectTarget(record)">选择</a></template>
        </a-table>
      </a-modal>

      <a-modal
        title="撤销跟进记录"
        :visible="revokeVisible"
        :confirm-loading="revoking"
        ok-text="确认撤销"
        @ok="submitRevoke"
        @cancel="revokeVisible=false">
        <a-alert type="warning" show-icon message="撤销后记录不会删除，系统将重新计算对应对象的最近跟进时间。" style="margin-bottom:16px" />
        <a-textarea v-model.trim="revokeReason" :rows="4" maxlength="500" placeholder="请输入撤销原因（必填）" />
      </a-modal>
    </div>
  </page-header-wrapper>
</template>

<script>
import moment from 'moment'
import { getDicts } from '@/api/system/dict/data'
import { pageUser } from '@/api/system/user'
import { pageCustomer, getCustomer } from '@/api/erp/customer'
import { pageCrmLead, getCrmLead, pageCrmFollowUp, addCrmFollowUp, editCrmFollowUp, revokeCrmFollowUp } from '@/api/erp/crm'
import CrmFollowUpUpload from '@/components/CrmFollowUpUpload'

export default {
  name: 'ErpCrmFollowUp',
  components: { CrmFollowUpUpload },
  data () {
    return {
      query: { targetType: undefined, targetId: undefined, followUpMethod: undefined, status: undefined },
      rows: [],
total: 0,
pageNum: 1,
pageSize: 10,
loading: false,
editorVisible: false,
readOnly: false,
saving: false,
      revokeVisible: false,
revoking: false,
revokeId: undefined,
revokeReason: '',
viewportWidth: window.innerWidth,
      form: {},
selectedTargetName: '',
targetPickerVisible: false,
targetKeyword: '',
targetLoading: false,
targetOptions: [],
methods: [],
interviewTypes: [],
userOptions: [],
targetLabelMap: {},
      pickerColumns: [
        { title: '编号', dataIndex: 'code', width: 180 },
        { title: '名称', dataIndex: 'name', width: 200, ellipsis: true },
        { title: '联系人', dataIndex: 'contactName', width: 110 },
        { title: '手机号', dataIndex: 'mobile', width: 135 },
        { title: '经营主体', dataIndex: 'operatingSubjectId', width: 140, scopedSlots: { customRender: 'operatingSubject' } },
        { title: '操作', key: 'pickerOperation', width: 80, fixed: 'right', scopedSlots: { customRender: 'pickerOperation' } }
      ],
      columns: [
        { title: '记录编号', dataIndex: 'followUpNo', width: 220, scopedSlots: { customRender: 'followUpNo' } },
        { title: '对象类型', dataIndex: 'targetType', width: 100, scopedSlots: { customRender: 'targetType' } },
        { title: '关联对象', dataIndex: 'targetId', width: 280, ellipsis: true, scopedSlots: { customRender: 'target' } },
        { title: '方式', dataIndex: 'followUpMethod', width: 110, scopedSlots: { customRender: 'followUpMethod' } },
        { title: '跟进内容', dataIndex: 'content', width: 260, ellipsis: true },
        { title: '实际跟进时间', dataIndex: 'followUpTime', width: 165, scopedSlots: { customRender: 'dateTime' } },
        { title: '下次跟进时间', dataIndex: 'nextFollowUpTime', width: 165, scopedSlots: { customRender: 'dateTime' } },
        { title: '附件', key: 'attachmentCount', width: 90, scopedSlots: { customRender: 'attachmentCount' } },
        { title: '状态', dataIndex: 'status', width: 100, scopedSlots: { customRender: 'status' } },
        { title: '跟进人', dataIndex: 'creator', width: 120, scopedSlots: { customRender: 'user' } },
        { title: '操作', key: 'operation', width: 130, fixed: 'right', scopedSlots: { customRender: 'operation' } }
      ]
    }
  },
  computed: {
    currentSubjectId () { const value = this.$store.state.user.info && this.$store.state.user.info.operatingSubjectId; return value == null ? 0 : Number(value) },
    drawerWidth () { return this.viewportWidth < 900 ? '100%' : '88%' },
    pagination () { return { current: this.pageNum, pageSize: this.pageSize, total: this.total, showTotal: total => `共 ${total} 条`, showSizeChanger: true } }
  },
  created () {
    Promise.all([this.loadDictionaries(), this.loadUsers()]).then(this.openRoutedTodo).finally(this.loadRows)
    window.addEventListener('resize', this.updateViewport)
  },
  beforeDestroy () { window.removeEventListener('resize', this.updateViewport) },
  methods: {
    updateViewport () { this.viewportWidth = window.innerWidth },
    openRoutedTodo () {
      if (this.$route.query.action === 'create') {
        this.openAdd()
        this.$router.replace({ path: this.$route.path })
        return Promise.resolve()
      }
      const targetType = this.$route.query.targetType
      const targetId = this.$route.query.targetId
      if (!targetId || !['lead', 'customer'].includes(targetType)) return Promise.resolve()
      const request = targetType === 'customer' ? getCustomer(targetId) : getCrmLead(targetId)
      return request.then(res => {
        const target = res.data || {}
        this.followTodo({
          targetType,
          targetId: target.id,
          targetCode: targetType === 'customer' ? target.customerCode : target.leadNo,
          targetName: targetType === 'customer' ? target.customerName : target.companyName,
          operatingSubjectId: target.operatingSubjectId
        })
        this.$router.replace({ path: this.$route.path })
      }).catch(() => {})
    },
    async loadDictionaries () { const [methods, interviews] = await Promise.all([getDicts('erp_crm_follow_method'), getDicts('erp_crm_interview_type')]); this.methods = methods.data || []; this.interviewTypes = interviews.data || [] },
    loadUsers () { return pageUser({ pageNum: 1, pageSize: 500, status: 1 }).then(res => { this.userOptions = (res.data && res.data.records) || [] }) },
    loadRows () { this.loading = true; pageCrmFollowUp({ ...this.query, operatingSubjectId: this.currentSubjectId, pageNum: this.pageNum, pageSize: this.pageSize }).then(res => { this.rows = (res.data && res.data.records) || []; this.total = Number((res.data && res.data.total) || 0); return this.loadTargetLabels(this.rows) }).finally(() => { this.loading = false }) },
    search () { this.pageNum = 1; this.loadRows() },
    resetQuery () { this.query = { targetType: undefined, targetId: undefined, followUpMethod: undefined, status: undefined }; this.search() },
    changePage (pagination) { this.pageNum = pagination.current; this.pageSize = pagination.pageSize; this.loadRows() },
    openAdd () { this.form = { targetType: 'lead', targetId: undefined, operatingSubjectId: undefined, followUpMethod: undefined, interviewType: undefined, followUpTime: moment().format('YYYY-MM-DD HH:mm:ss'), nextFollowUpTime: undefined, content: '', locationText: '', photoUrls: '', attachmentUrls: '' }; this.selectedTargetName = ''; this.readOnly = false; this.editorVisible = true },
    followTodo (record) {
      this.form = { targetType: record.targetType, targetId: record.targetId, operatingSubjectId: record.operatingSubjectId, followUpMethod: undefined, interviewType: undefined, followUpTime: moment().format('YYYY-MM-DD HH:mm:ss'), nextFollowUpTime: undefined, content: '', locationText: '', photoUrls: '', attachmentUrls: '' }
      this.selectedTargetName = `${record.targetCode || ''} ${record.targetName || ''}`.trim()
      this.$set(this.targetLabelMap, `${record.targetType}:${record.targetId}`, this.selectedTargetName)
      this.readOnly = false
      this.editorVisible = true
    },
    openEdit (record) { this.form = { ...record, followUpTime: this.normalTime(record.followUpTime), nextFollowUpTime: this.normalTime(record.nextFollowUpTime) }; this.selectedTargetName = this.targetLabel(record); this.readOnly = false; this.editorVisible = true },
    openView (record) { this.form = { ...record, followUpTime: this.normalTime(record.followUpTime), nextFollowUpTime: this.normalTime(record.nextFollowUpTime) }; this.selectedTargetName = this.targetLabel(record); this.readOnly = true; this.editorVisible = true },
    closeEditor () { this.editorVisible = false; this.readOnly = false; this.form = {}; this.selectedTargetName = '' },
    changeTargetType () { this.form.targetId = undefined; this.form.operatingSubjectId = undefined; this.selectedTargetName = ''; this.targetOptions = [] },
    openTargetPicker () { this.targetKeyword = ''; this.targetPickerVisible = true; this.loadTargetOptions() },
    loadTargetOptions () {
      this.targetLoading = true
      const isCustomer = this.form.targetType === 'customer'
      const request = isCustomer
        ? pageCustomer({ customerName: this.targetKeyword, operatingSubjectId: this.currentSubjectId, status: 'enabled', pageNum: 1, pageSize: 50 })
        : pageCrmLead({ keyword: this.targetKeyword, operatingSubjectId: this.currentSubjectId, assignmentStatus: 'assigned', status: 'enabled', pageNum: 1, pageSize: 50 })
      request.then(res => {
        const records = (res.data && res.data.records) || []
        this.targetOptions = records.filter(item => item.assignmentStatus !== 'in_pool' && Number(item.operatingSubjectId == null ? 0 : item.operatingSubjectId) === this.currentSubjectId).map(item => ({
          id: item.id,
          code: isCustomer ? item.customerCode : item.leadNo,
          name: isCustomer ? item.customerName : item.companyName,
          contactName: item.contactName,
          mobile: item.mobile,
          operatingSubjectId: item.operatingSubjectId
        }))
      }).finally(() => { this.targetLoading = false })
    },
    selectTarget (record) { this.form.targetId = record.id; this.form.operatingSubjectId = record.operatingSubjectId; this.selectedTargetName = `${record.code || ''} ${record.name || ''}`.trim(); this.$set(this.targetLabelMap, `${this.form.targetType}:${record.id}`, this.selectedTargetName); this.targetPickerVisible = false },
    submit () { if (!this.form.targetType || !this.form.targetId || this.form.operatingSubjectId === undefined || !this.form.followUpMethod || !this.form.followUpTime || !this.form.content) return this.$message.warning('请填写对象、经营主体、跟进方式、实际时间和内容'); this.saving = true; const action = this.form.id ? editCrmFollowUp : addCrmFollowUp; action(this.form).then(() => { this.$message.success('跟进记录已保存'); this.closeEditor(); this.loadRows() }).finally(() => { this.saving = false }) },
    openRevoke (record) { this.revokeId = record.id; this.revokeReason = ''; this.revokeVisible = true },
    submitRevoke () { if (!this.revokeReason) return this.$message.warning('请输入撤销原因'); this.revoking = true; revokeCrmFollowUp(this.revokeId, this.revokeReason).then(() => { this.$message.success('跟进记录已撤销'); this.revokeVisible = false; this.loadRows() }).finally(() => { this.revoking = false }) },
    dictLabel (list, value) { const found = list.find(item => item.dictValue === value); return found ? found.dictLabel : (value || '—') },
    subjectLabel (id) { return Number(id == null ? 0 : id) === this.currentSubjectId ? '默认经营主体' : `经营主体 #${id}` },
    userLabel (id) { if (id == null) return '—'; const user = this.userOptions.find(item => String(item.id) === String(id)); return user ? (user.nickName || user.userName) : `用户 #${id}` },
    targetLabel (record) { return this.targetLabelMap[`${record.targetType}:${record.targetId}`] || `${record.targetType === 'customer' ? '客户' : '线索'} #${record.targetId}` },
    attachmentCount (record) { return this.splitUrls(record.photoUrls).length + this.splitUrls(record.attachmentUrls).length },
    splitUrls (value) { return String(value || '').split(',').map(item => item.trim()).filter(Boolean) },
    loadTargetLabels (rows) {
      const tasks = (rows || []).map(record => {
        const key = `${record.targetType}:${record.targetId}`
        if (this.targetLabelMap[key]) return Promise.resolve()
        const request = record.targetType === 'customer' ? getCustomer(record.targetId) : getCrmLead(record.targetId)
        return request.then(res => {
          const data = res.data || {}
          const code = record.targetType === 'customer' ? data.customerCode : data.leadNo
          const name = record.targetType === 'customer' ? data.customerName : data.companyName
          this.$set(this.targetLabelMap, key, `${code || ''} ${name || ''}`.trim() || `${record.targetType === 'customer' ? '客户' : '线索'} #${record.targetId}`)
        }).catch(() => {})
      })
      return Promise.all(tasks)
    },
    normalTime (value) { return value ? String(value).replace('T', ' ').slice(0, 19) : undefined },
    formatTime (value) { return value ? String(value).replace('T', ' ').slice(0, 16) : '—' }
  }
}
</script>

<style scoped>
.follow-grid{grid-template-columns:repeat(4,minmax(160px,1fr))}.target-picker-field{grid-column:span 2}.crm-picker-search{max-width:520px;margin-bottom:16px}.crm-follow-upload-field{display:flex;min-width:0;flex-direction:column;gap:7px}.crm-follow-upload-field>span{color:#475467;font-size:13px}@media(max-width:1100px){.follow-grid{grid-template-columns:1fr 1fr}.target-picker-field{grid-column:span 1}}@media(max-width:700px){.follow-grid{grid-template-columns:1fr}}
</style>
